import { createStore } from 'vuex'
import { getEmptyState } from '@/store/state'
import { mutations } from '@/store/mutations'
import { actions } from '@/store/actions'
import { Project } from '@/types/descript_kundenverwaltung_rest'


export const store = createStore({
  state: getEmptyState(),
  mutations: mutations,
  actions: actions,
  getters: {
    getProjectById: (state) => (projectId: number) => {
      return state.projects.find(project => project.id == projectId)
    }
  }
})
